module.exports = __webpack_public_path__ + "static/10-6c9f979250df98a9deca44c50251bf98.jpeg";